/* eslint-disable @next/next/no-img-element */
import React, { useEffect } from 'react'
import LazyLoad from 'react-lazyload'
import parse from 'html-react-parser'
import { motion } from 'framer-motion'

export const AboutSection = ({ data }: any) => {
  const dataAbout = data?.items?.find((item: any) => item?.identifier == 'home-page-services')
  return (
    <LazyLoad>
      <div className="about-section">
        <div className="inner">
          <motion.div
            className="img-position"
            initial={{ x: '-100%', opacity: 0, filter: 'blur(8px)' }}
            animate={{ x: 0, opacity: 1, filter: 'blur(0px)' }}
            transition={{ duration: 1.2, ease: 'easeOut', delay: 0.2 }}
          >
            <div className="img-main">
              <motion.div
                className="pos-main"
                animate={{ y: [-5, 5, -5] }}
                transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
              >
                <img src="/image/lop-xe.png" alt="" />
              </motion.div>
              <motion.div
                className="pos1"
                animate={{ y: [0, -8, 0] }}
                transition={{ duration: 2.5, repeat: Infinity, ease: 'easeInOut', delay: 0.2 }}
              >
                <img src="/image/dolce.png" alt="" />
              </motion.div>
              <motion.div
                className="pos2"
                animate={{ y: [-4, 6, -4] }}
                transition={{ duration: 3.5, repeat: Infinity, ease: 'easeInOut', delay: 0.5 }}
              >
                <img src="/image/remote-ha.png" alt="" />
              </motion.div>
              <motion.div
                className="pos3"
                animate={{ y: [3, -5, 3] }}
                transition={{ duration: 2.8, repeat: Infinity, ease: 'easeInOut', delay: 0.3 }}
              >
                <img src="/image/go-dau.png" alt="" />
              </motion.div>
              <motion.div
                className="pos4"
                animate={{ y: [-3, 7, -3] }}
                transition={{ duration: 3.2, repeat: Infinity, ease: 'easeInOut', delay: 0.7 }}
              >
                <img src="/image/po-do.png" alt="" />
              </motion.div>
            </div>
          </motion.div>
          <div className="img-position-right">
            <motion.img
              src="/image/21.png"
              alt=""
              animate={{ y: [-8, 8, -8], rotate: [-2, 2, -2] }}
              transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
            />
          </div>
          <div className="bg-about-top max-lg:hidden">
            <img src="/image/bg-about-top.png" alt="" className="" />
          </div>
          <div className="bg-about-mid">
            <div className="img">
              <img src="/image/bg-about-mid.png" alt="" />
            </div>
          </div>
          <div className="bg-about-bot max-lg:hidden">
            <img src="/image/bg-about-bot.png" alt="" className="" />
          </div>
          <div className="containers">
            <div className="content-about-section">
              <div className="content-inner">
                {dataAbout?.nodes.items.map((item: any, index: number) => {
                  return (
                    <motion.div
                      className="item"
                      key={index}
                      initial={{ x: '55%', opacity: 0, filter: 'blur(8px)' }}
                      whileInView={{ x: 0, opacity: 1, filter: 'blur(0px)' }}
                      viewport={{ once: true, amount: 0.3 }}
                      transition={{ duration: 0.5, ease: 'easeOut', delay: index * 0.2 }}
                    >
                      <div className="img w-full">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="text">
                        <div className="title">{item.title}</div>
                        <div className="subtext">{item.content ? parse(item.content) : ''}</div>
                      </div>
                    </motion.div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LazyLoad>
  )
}
